"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VisaDetailsTask = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const designed_1 = require("designed");
const VisaDetails_1 = require("../../../visa/models/VisaDetails");
const BaseTask_1 = require("../Task/BaseTask");
class VisaDetailsTask extends BaseTask_1.BaseTask {
}
(0, tslib_1.__decorate)([
    designed_1.Entity.Field(),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInstance)(VisaDetails_1.VisaDetails),
    (0, tslib_1.__metadata)("design:type", VisaDetails_1.VisaDetails)
], VisaDetailsTask.prototype, "visaDetails", void 0);
exports.VisaDetailsTask = VisaDetailsTask;
